import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

interface ISelectProductcopy_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISelectProductcopy_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetFatura: any[];
  GetFatura_dummy: any[];
  WriteToSessionStorage: string;
  WriteToSessionStorage_dummy: string;
  GoBack: string;
  GoBack_dummy: string;
  wfScreenName: string;
}

export class SelectProductcopy_ScreenBase extends React.PureComponent<ISelectProductcopy_ScreenProps, any> {
  selectproductcopy_600449_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "4f05fda5-b043-9e86-8437-71ea4357a314",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: []
    },
    { Id: "7a8fc238-9831-4128-a954-0cdac59f257a", Name: "en_US", ShortName: "English", LanguagePhrases: [] },
    {
      Id: "0afadeed-1c37-4561-a164-116cdd44aebe",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 600449, PropertyName: "nodatafoundmessage", Value: "Fatura Bilgisi Bulunamadı" },
        { Id: 213126, PropertyName: "title", Value: "Ad Soyad" },
        { Id: 213108, PropertyName: "value", Value: "[datafield:adsoyad]" },
        { Id: 816776, PropertyName: "title", Value: "Fatura Numarası" },
        { Id: 891411, PropertyName: "value", Value: "[datafield:faturano]" },
        { Id: 794014, PropertyName: "title", Value: "Ürün Kodu" },
        { Id: 397524, PropertyName: "value", Value: "[datafield:urunkodu]" },
        { Id: 167096, PropertyName: "title", Value: "Fatura Tarihi" },
        { Id: 845716, PropertyName: "value", Value: "[datafield:faturatarihi]" },
        { Id: 536642, PropertyName: "title", Value: "Mağaza" },
        { Id: 954743, PropertyName: "value", Value: "[datafield:magaza]" },
        { Id: 986338, PropertyName: "title", Value: "Ürün Grubu" },
        { Id: 158546, PropertyName: "value", Value: "[datafield:urungrubu]" },
        { Id: 566619, PropertyName: "title", Value: "Mağaza Kodu" },
        { Id: 185328, PropertyName: "value", Value: "[datafield:magazakodu]" },
        { Id: 333202, PropertyName: "title", Value: "Renk Adı" },
        { Id: 625735, PropertyName: "value", Value: "[datafield:renkadi]" },
        { Id: 302536, PropertyName: "title", Value: "Renk Kodu" },
        { Id: 28557, PropertyName: "value", Value: "[datafield:renkkodu]" },
        { Id: 135443, PropertyName: "title", Value: "Ürün Alt Kategori" },
        { Id: 296665, PropertyName: "value", Value: "[datafield:urunaltkategori]" },
        { Id: 256636, PropertyName: "title", Value: "Ürün Kategorisi" },
        { Id: 521581, PropertyName: "value", Value: "[datafield:urunkategori]" }
      ]
    }
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.selectproductcopy_600449_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetFatura: [],
      WriteToSessionStorage: "",
      GoBack: "",
      wfScreenName: ""
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("selectproductcopy", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.SelectProductcopyPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("selectproductcopy", "");
  }

  componentWillUnmount() {}

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("selectproductcopy", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.SelectProductcopyPageInit();
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: []
        }
      ]);
    }
  };

  SelectProductcopyPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    let localVar = {
      GSM_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerPhone ?? this.props.screenInputs.customerphone,
        "string"
      ),
      FaturaNo_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.InvoiceNumber ?? this.props.screenInputs.invoicenumber,
        "string"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "SelectProductcopy/SelectProductcopyPageInit", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetFatura = result?.data.getFatura;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SelectProductcopyPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SelectProductcopyPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }

    stateVars.dataSource_600449 = this.state.GetFatura;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  SelectProductcopyComponent_31264_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.WriteToSessionStorage = await ReactSystemFunctions.writeToSessionStorage(
      ReactSystemFunctions.convertToTypeByName("SelectedFaturaNo", "string"),
      ReactSystemFunctions.value(this, "selectproductcopy_600449_value", "faturaNo")
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }

  getWfPageComponent = () => {
    return ReactSystemFunctions.getWfPageComponent(this, this.state.wfScreenName);
  };
}
